import { createTheme } from "@mui/material";

const theme = createTheme({
	palette: {
		primary: {
			main: "#545CF4",
			contrastText: "#fff",
		},
	},
});

export default theme;
